import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  link: {
    textDecoration: "none",
    color: "inherit",
  },
}));
